import styled from 'styled-components'

export const Field = styled.div`
    margin: 5px 0;
`
